import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import UomSettings from './UomSettings'
import PriceListSettings from './PriceListSettings'

const ProductServiceSettings = () => {
    const {t} = useTranslation('global');
    const [activeTab, setActiveTab] = useState('units');

    return (
        <>
            <div className='w-full'>
                <div className='flex justify-between items-center mb-4'>
                    <div className='text-lg font-semibold text-gray-700'>
                        {t('settings.productServiceSettings')}: 
                    </div>
                </div>
                <div className='flex gap-2 border-b border-slate-200 mb-3'>
                    <button
                        type="button"
                        className={`px-4 py-2 text-sm rounded-t-lg ${activeTab === 'units' ? 'bg-slate-50 font-semibold' : 'bg-transparent text-slate-500 hover:bg-slate-50'}`}
                        onClick={() => setActiveTab('units')}
                    >
                        {t('productServiceTabs.units')}
                    </button>
                    <button
                        type="button"
                        className={`px-4 py-2 text-sm rounded-t-lg ${activeTab === 'priceLists' ? 'bg-slate-50 font-semibold' : 'bg-transparent text-slate-500 hover:bg-slate-50'}`}
                        onClick={() => setActiveTab('priceLists')}
                    >
                        {t('productServiceTabs.priceLists')}
                    </button>
                </div>

                {activeTab === 'units' && (
                    <div className='mt-3 rounded-xl border border-slate-100 bg-white p-3'>
                        <UomSettings />
                    </div>
                )}
                {activeTab === 'priceLists' && (
                    <div className='mt-3 rounded-xl border border-slate-100 bg-white p-3'>
                        <PriceListSettings />
                    </div>
                )}
            </div>
        </>
    )
}

export default ProductServiceSettings
